<template>
    <div class="land-location-gal">
        <div class="container">
            <div class="column-container">
                <div class="col-left">
                    <div class="land-section-title">
                        <h2>{{salesCard.project_land_site.location_second_title}}</h2>
                        <h3>{{salesCard.project_land_site.location_second_title_desc}}</h3>
                    </div>
                    <div class="land-location-second">
                        <div class="desc-col-html-mini" v-html="salesCard.project_land_site.location_second_desc"></div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="location-gallery" :class="{'nav-init' : salesCard.project_land_site.location_second_gallery != undefined && salesCard.project_land_site.location_second_gallery.length > 1}">
                        <swiper :options="swiperOption" ref="landLocSecondLocation">
                            <swiper-slide v-for="(slide, index) in salesCard.project_land_site.location_second_gallery" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="swiper-controls sales-land-controls sales-land-location-second-controls" v-if="salesCard.project_land_site.location_second_gallery != undefined && salesCard.project_land_site.location_second_gallery.length > 1">
                        <div class="container">
                            <div class="sales-land-btn-prev sales-land-loc-btn-prev slider-btn">
                                <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                            </div>
                            <div class="sales-land-btn-next sales-land-loc-btn-next slider-btn">
                                <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sales-land-pagination sales-land-location-second-pagination" v-if="salesCard.project_land_site.location_second_gallery != undefined && salesCard.project_land_site.location_second_gallery.length > 1"></div>
                </div>
            </div>
            
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-gal',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-land-loc-btn-next',
                        prevEl: '.sales-land-loc-btn-prev',
                    },
                    pagination: {
                        el: '.sales-land-location-second-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-location-gal.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-location-gal-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>